module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMask),
      expression: "showMask"
    }],
    staticClass: "page-mask",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('h1', [_vm._v("活动已结束，下次记得早点来哦~~~")]), _vm._v(" "), (_vm.showMask) ? _c('div', {
    staticClass: "mask",
    staticStyle: {
      "z-index": "99999"
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-700f3024!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FullMask.vue
// module id = 13
// module chunks = 2 3 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56 57 58 59 60 61 62 65 66 83 84 85 86 87 88 89 90 125 126 127 128 129 130 139 140 141 142 143 144 145